import {createFilterUI, filterUI} from './filterUI';

export class filter {
    public constructor(private ui: filterUI) {
      this.registerEvents();
    }

    private registerEvents() {
      this.ui.onFilterClick((filterGroupName: string) => this.filterByFilterGroup(filterGroupName));
    }

    private filterByFilterGroup(filterGroupName: string) {
      this.ui.filterByCategoryName(filterGroupName);
    }
}

export function initFilter() {
    const uiInstance = createFilterUI();
    const instance = uiInstance.map((uiInstance: filterUI) => {
        return new filter(uiInstance);
    });
}
